// src/hooks/actions/useOverallActions.ts

import { useCallback } from 'react';
import { IBuildingProviderContext } from '../../../@types/ContextProviderRelated';
import { EHistoryAction } from '../../../hooks/useUndoRedo';
import CompassModel from '../../../models/standard/CompassModel';
import PlanModel from '../../../models/standard/PlanModel';
import exportPlanJson from '../../../utils/export/exportPlanJson';
import { useAnnotations } from '../../AnnotationsProvider';

export interface IOverallActions {
  /**
   * Resets the building to its default configuration.
   */
  resetBuildingToDefaults: () => void;
  /**
   * Exports the current plan as a JSON string.
   */
  exportPlan: () => string;
}

export const useOverallActions = (
  building: IBuildingProviderContext,
  setBuilding: React.Dispatch<React.SetStateAction<IBuildingProviderContext>>,
  planModel: PlanModel,
): IOverallActions => {
  const { measurements, cameraPositionSprites, hotspots } = useAnnotations();

  const resetBuildingToDefaults = useCallback(async (): Promise<void> => {
    const defaultBuilding: IBuildingProviderContext = {
      compass: new CompassModel(),
      rooms: [],
      walls: [],
      products: [],
      elements: [],
      models2D: [],
      isSetByUndoRedo: false,
      lastAction: EHistoryAction.RESET_TO_DEFAULT,
      nonFetchableEntities: [],
      relations: [...building.relations],
    };
    setBuilding(defaultBuilding);
  }, [setBuilding]);

  const exportPlan = useCallback(
    (): string => exportPlanJson(planModel, building, measurements, cameraPositionSprites, hotspots, building.nonFetchableEntities, building.relations),
    [planModel, building, measurements, cameraPositionSprites, hotspots],
  );

  return {
    resetBuildingToDefaults,
    exportPlan,
  };
};
